/* React */
import React from "react";

/* Ionic */
import { IonItem, IonIcon } from "@ionic/react";
import {
  ellipseOutline,
  radioButtonOn,
} from "ionicons/icons";

/* Stylesheet */
import styles from "./FilterItem.module.scss";

/* Interfaces */
interface FilterItemProps {
  treatmentLine: string;
  isActive: boolean;
  onClick: (treatmentLine: string) => void;
}

const FilterItem: React.FC<FilterItemProps> = ({
  treatmentLine,
  isActive,
  onClick,
}) => {
  return (
    <IonItem
      className={styles.filter_item}
      lines="none"
      button
      onClick={() => {
        onClick(treatmentLine);
      }}
    >
      <div className={styles.label}>
        <IonIcon
          className={styles.icon}
          icon={isActive ? radioButtonOn : ellipseOutline}
        />
        <div className={styles.treatment_line}>
          {treatmentLine}
        </div>
      </div>
    </IonItem>
  );
};

export default FilterItem;
